import "../css/App.css";
import Navbar from "../components/navbar";
import Home from "../components/home";
import About from "../components/about";
import Docs from "../components/documentation";
import Footer from "../components/footer";

function HomePage() {
  return (
    <div>
      <Navbar />
      <Home />
      <Footer />
    </div>
  );
}

export function AboutPage() {
  return (
    <body>
      <Navbar />
      <About />
      <Footer />
    </body>
  );
}

export function DocumentationPage() {
  return (
    <body>
      <Navbar />
      <Docs />
      <Footer />
    </body>
  );
}

export function App() {
  return <HomePage />;
}
